import { Box, Grid, Typography } from '@mui/material';
import './WriteLetter.css';
import { writeLetter } from '@/components/common/commonJson';
import { useEffect, useRef } from 'react';
import { Camera, Gift, ShieldCheck, Sparkles } from 'lucide-react';

const iconMap = {
  Camera: Camera,
  Gift: Gift,
  ShieldCheck: ShieldCheck,
  Sparkles: Sparkles
};

const WriteLetter = () => {

  const scrollAreaRef = useRef(null);

    useEffect(() => {
        const scrollableElement = scrollAreaRef.current;
        if (!scrollableElement) return;

        const handleWheel = (event) => {
           
            const hasVerticalScroll = scrollableElement.scrollHeight > scrollableElement.clientHeight;

            if (hasVerticalScroll) {
                if (event.deltaY > 0 && scrollableElement.scrollTop + scrollableElement.clientHeight < scrollableElement.scrollHeight - 2) { 
                    event.stopPropagation(); 
                }
                else if (event.deltaY < 0 && scrollableElement.scrollTop > 2) { 
                    event.stopPropagation(); 
                }
            }
        };

        scrollableElement.addEventListener('wheel', handleWheel);

        
        return () => {
            scrollableElement.removeEventListener('wheel', handleWheel);
        };
    }, []);

    const renderIcon = (iconName) => {
        const IconComponent = iconMap[iconName] || Sparkles;
        return <IconComponent size={32} strokeWidth={1.5} />;
    };

    return (
        <Box className='writeLetter' id='testimonial'>
            <Box className='container'>
            <div className="write-letter-scroll-area" ref={scrollAreaRef}>
                <Grid container spacing={4} className='pad container-grid'>
                    <Grid item xl={3} xs={12} md={3} lg={4}>
                        {writeLetter?.map((val, index) => {
                            return (
                                index < 2 &&
                                <Box className='write_box mr' key={index}>
                                    <Box className='icon_shape'>
                                        {renderIcon(val.lucideIcon)}
                                    </Box>
                                    <Typography variant='h3'>{val?.title}</Typography>
                                    <Typography variant='p' style={{
                                        textAlign:'center'
                                    }}>{val?.describe}</Typography>
                                </Box>
                            )
                        })}
                    </Grid>
                    <Grid item xl={3} xs={12} md={3} lg={4}>
                        {writeLetter?.map((val, index) => {
                            return (
                                index >= 2 &&
                                <Box className='write_box mr' key={index}>
                                    <Box className='icon_shape'>
                                        {renderIcon(val.lucideIcon)}
                                    </Box>
                                    <Typography variant='h3'>{val?.title}</Typography>
                                    <Typography variant='p' style={{
                                        textAlign:'center'
                                    }}>{val?.describe}</Typography>
                                </Box>
                            )
                        })}
                    </Grid>
                </Grid>
            </div>
            </Box>
        </Box>
    )
}

export default WriteLetter